import React from 'react';

import { PATH } from 'src/pages/taxExchangeSetting';
import Layout from 'src/components/layout';
import loadable from 'src/utils/loadable';
import { IRouter } from 'src/interfaces/route';
import { t } from 'src/libs/i18n';
import { SCREENS } from 'src/constants/screens';

const TaxExchangeSetting: IRouter[] = [
  {
    element: <Layout />,
    children: [
      {
        path: PATH,
        element: loadable(() => import('src/pages/taxExchangeSetting')),
        title: t('menu_home.tax_exchange_setting'),
        screenId: SCREENS.R1509,
      },
    ],
  },
];

export default TaxExchangeSetting;
